import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import Link from "next/link";

import SortIcons from "../SortIcons/SortIcons";
import TabBar from "@/shared/components/Tabs/TabBar";
import { TabColumns, Tabs, Tab, IdsTabs } from "./Abbreviations.constants";

import { sortByField, SortDirection } from "@/shared/utils/array";
import { getBookIdWithPrefix } from "@/shared/utils/content/content";
import { URLS } from "@/shared/utils/url/url";
import { getOptionKey } from "@/shared/utils/select";

import styles from "./abbreviations.module.scss";

const Abbreviations = ({ abbreviations }) => {
  const { t } = useTranslation();
  const router = useRouter();

  const [sortDirection, setSortDirection] = useState(null);
  const [activeField, setActiveField] = useState(null);

  const { list, type } = useMemo(() => {
    const typeQuery = router.query.type;
    const type = IdsTabs.includes(typeQuery) ? typeQuery : Tab.EGW;
    const list = abbreviations[type] || [];

    return {
      list: sortDirection ? sortByField(list, activeField, sortDirection) : list,
      type,
    };
  }, [abbreviations, activeField, sortDirection, router.query.type]);

  const rendererList = list.map((item) => (
    <div key={item.link} className={styles["abbreviation-table-row"]}>
      <span className={styles["abbreviation-code"]}>{item.abbreviations.join(", ")}</span>
      <span className={styles["abbreviation-book-name"]}>
        <Link href={URLS.book + "/" + getBookIdWithPrefix(item.link)} passHref>
          {item.title}
        </Link>
      </span>
      <span className={styles["abbreviation-publication"]}>{item.pub_year}</span>
    </div>
  ));

  const handleChangeTab = (key) => {
    const tab = Tabs.find((o) => getOptionKey(o) === key);
    router.replace(tab.url);

    setActiveField(null);
    setSortDirection(null);
  };

  const handleClickColumnHeader = (filedName) => {
    setActiveField(filedName);
    if (sortDirection === SortDirection.ASC) {
      setSortDirection(SortDirection.DESC);
    } else if (sortDirection === SortDirection.DESC) {
      setSortDirection(null);
    } else {
      setSortDirection(SortDirection.ASC);
    }
  };

  return (
    <div className={classNames(styles["abbreviation-wrap"], { [styles[type]]: type })}>
      <TabBar
        activeTabClassName={styles["active"]}

        alignLeft

        options={Tabs}

        current={type}
        onSelectTab={handleChangeTab}
      />
      <div
        className={classNames(
          styles["abbreviation-table-header"],
          styles["abbreviation-table-row"],
        )}>
        {TabColumns.map(({ className, title, filedName }) => (
          <div
            key={title}
            onClick={() => handleClickColumnHeader(filedName)}
            className={classNames(styles["abbreviation-row-item"], styles[className])}>
            <div className={styles["table-column-item__body"]}>
              <span>{t(title)}</span>
              <SortIcons
                highlightCurrent={activeField === filedName}
                sortDirection={sortDirection}
              />
            </div>
          </div>
        ))}
      </div>
      <div className={styles["abbreviation-content"]}>{rendererList}</div>
    </div>
  );
};

Abbreviations.propTypes = {
  abbreviations: PropTypes.object,
};

export default Abbreviations;
